import {
	crudClearValuesStore,
	crudCreateValue,
	crudGetValuesList
} from 'actions'
import TableWithSelection from 'components/abmUtils/TableWithSelection'
import ConfirmModalNoButton from 'components/common/ConfirmModalNoButton'
import { ICrudFieldStructure, ICrudsApi } from 'models/CrudInterface'
import { ITableWithSelectionFields } from 'models/TableWithSelection'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'

interface ValuesTableProps extends WithTranslation {
	fields: Array<ICrudFieldStructure>
	atributeCode: string | number
	urlApi: string
	crudGetValuesList: (params: ICrudsApi) => void
	crudCreateValue: (params: ICrudsApi) => void
	valuesList: any
	valueUpdated: any
	tabId: string
	valueId: string
	crudId: string
	setFormChanged: (formChanged: boolean) => void
	showWarning: boolean
	handleWarning: (value: any, action: string) => void
	t: any
	disableForm: boolean
}

type ValuesTableState = {
	showEditPopup: boolean
	disablePopup: boolean
	alta: number
	errorTitle: string
	errorMessage: string
	typeNotification: string
	showError: boolean
	selectRow: number
	titleModal: string
	sustainsClick: boolean
	selectedLeft: Array<string>
	selectedRight: Array<string>
	leftValues: Array<any>
	rightValues: Array<any>
	initialRightValues: Array<any>
	searchLeft: string
	searchRight: string
}

class DynamicTable extends Component<ValuesTableProps, ValuesTableState> {
	constructor(props: ValuesTableProps) {
		super(props)
		this.state = {
			showEditPopup: false,
			disablePopup: true,
			alta: 0,
			errorTitle: '',
			errorMessage: '',
			typeNotification: 'success',
			showError: false,
			selectRow: 0,
			titleModal: '',
			selectedLeft: [],
			selectedRight: [],
			sustainsClick: false,
			leftValues: [],
			rightValues: [],
			searchLeft: '',
			searchRight: '',
			initialRightValues: []
		}
	}

	componentDidMount = () => {
		const { atributeCode, crudGetValuesList, urlApi, crudId, tabId } =
			this.props

		crudGetValuesList({
			crudName: crudId,
			urlApi: urlApi,
			action: 'sel',
			params: {
				[tabId]: atributeCode
			}
		})
	}

	/**
	 * Checks if the values into the array changed to setup changed state
	 * @param prevState
	 */
	componentDidUpdate = (
		prevProps: ValuesTableProps,
		prevState: ValuesTableState
	) => {
		const { valuesList, setFormChanged } = this.props
		const { valuesList: prevValuesList } = prevProps
		const { rightValues } = this.state
		const { rightValues: prevRightValues } = prevState

		if (valuesList && rightValues !== prevRightValues) {
			setFormChanged(this.formChanged())
		}

		if (valuesList && prevValuesList !== valuesList) {
			this.setState({
				rightValues: valuesList.lista2,
				initialRightValues: valuesList.lista2,
				leftValues: valuesList.lista1
			})
		}
	}

	formChanged = () => {
		const { valueId } = this.props
		const { initialRightValues, rightValues } = this.state

		let result = false

		if (initialRightValues.length === rightValues.length) {
			for (let pos = 0; pos < initialRightValues.length; pos++) {
				if (
					(result = !rightValues.some(
						(rightValue) =>
							initialRightValues[pos][valueId] === rightValue[valueId]
					))
				)
					break
			}
		} else {
			result = true
		}

		return result
	}

	/**
	 * If click happens inside a table, setup sustain state to paint fields
	 * If click happens outside, clear selected values
	 * @param event
	 */
	handleMouseDown = (event: any) => {
		const { selectedLeft, selectedRight } = this.state
		if (
			event.target.children.length > 0 ||
			event.target.id === 'searchLeft' ||
			event.target.id === 'searchRight'
		) {
			this.setState({
				selectedLeft: selectedLeft.filter((id: any) => false),
				selectedRight: selectedRight.filter((id: any) => false)
			})
		} else {
			event.preventDefault()
			this.setState({ sustainsClick: true })
		}
	}

	/**
	 * Handles mouse up, sets sustained click to false
	 * @param event
	 */
	handleMouseUp = (event: any) => {
		event.preventDefault()
		this.setState({ sustainsClick: false })
	}

	/**
	 * to handle click on buttons, each button has a label to identify it
	 * @param side
	 */
	handleButtonClick = (side: string) => () => {
		const { valueId } = this.props
		const { selectedLeft, selectedRight, leftValues, rightValues } = this.state

		if (side === 'toRight') {
			// pass selected values to right
			const selectedFields: Array<any> = []

			_.forEach(selectedLeft, (field) => {
				const selectedField = _.find(leftValues, (value: any) => {
					return value[valueId] === field
				})
				selectedField && selectedFields.push(selectedField)
			})

			const newValues =
				selectedFields &&
				rightValues.concat(selectedFields).sort((a: any, b: any) => {
					return a[valueId].localeCompare(b[valueId])
				})

			this.setState(() => ({
				leftValues: leftValues.filter(
					(value: any) => !_.includes(selectedLeft, value[valueId])
				),
				selectedLeft: selectedLeft.filter(() => false),
				rightValues: newValues
			}))
		} else if (side === 'toLeft') {
			// pass selected values to left
			const selectedFields: Array<any> = []

			_.forEach(selectedRight, (field) => {
				const selectedField = _.find(rightValues, (value: any) => {
					return value[valueId] === field
				})
				selectedField && selectedFields.push(selectedField)
			})

			const newValues = leftValues
				.concat(selectedFields)
				.sort((a: any, b: any) => {
					return a[valueId].localeCompare(b[valueId])
				})

			this.setState(() => ({
				rightValues: rightValues.filter(
					(value: any) => !_.includes(selectedRight, value[valueId])
				),
				selectedRight: selectedRight.filter(() => false),
				leftValues: newValues
			}))
		} else if (side === 'allLeft') {
			// pass all values to left
			const newValues = leftValues
				.concat(rightValues)
				.sort((a: any, b: any) => {
					return a[valueId].localeCompare(b[valueId])
				})

			this.setState(() => ({
				leftValues: newValues,
				rightValues: rightValues.filter(() => false),
				selectedRight: selectedRight.filter(() => false)
			}))
		} else if (side === 'allRight') {
			// pass all values to right
			const newValues = rightValues
				.concat(leftValues)
				.sort((a: any, b: any) => {
					return a[valueId].localeCompare(b[valueId])
				})

			this.setState(() => ({
				rightValues: newValues,
				leftValues: leftValues.filter(() => false),
				selectedLeft: selectedLeft.filter(() => false)
			}))
		}
	}

	/**
	 * to handle double click events, gets called by the TableWithSelection comp
	 * @param side
	 * @param row
	 */
	handleDoubleClick = (side: string, row: string) => {
		const { valueId } = this.props
		const { leftValues, rightValues } = this.state
		if (side === 'leftTable') {
			// Click on left table
			const selectedField = _.find(leftValues, (value: any) => {
				return value[valueId] === row
			})

			const newValues =
				selectedField &&
				[...rightValues, selectedField].sort(function (a: any, b: any) {
					return a[valueId].localeCompare(b[valueId])
				})

			this.setState(() => ({
				leftValues: selectedField
					? leftValues.filter(
							(value: any) => value[valueId] !== selectedField[valueId]
					  )
					: leftValues,
				rightValues: newValues || rightValues
			}))
		}
		if (side === 'rightTable') {
			// Click on right table
			const selectedField = _.find(rightValues, (value: any) => {
				return value[valueId] === row
			})

			const newValues =
				selectedField &&
				[...leftValues, selectedField].sort(function (a: any, b: any) {
					return a[valueId].localeCompare(b[valueId])
				})

			selectedField &&
				this.setState(() => ({
					rightValues: selectedField
						? rightValues.filter(
								(value: any) => value[valueId] !== selectedField[valueId]
						  )
						: rightValues,
					leftValues: newValues || leftValues
				}))
		}
	}

	/**
	 * to handle selection state, gets labels as params
	 * @param selectedRow
	 * @param side
	 * @param action
	 */
	handleSelection = (selectedRow: string, side: string, action: string) => {
		const { selectedLeft, selectedRight } = this.state
		if (action === 'add') {
			side === 'leftTable' &&
				this.setState(() => ({
					selectedLeft: [...selectedLeft, selectedRow]
				}))
			side === 'rightTable' &&
				this.setState(() => ({
					selectedRight: [...selectedRight, selectedRow]
				}))
		} else if (action === 'delete') {
			side === 'leftTable' &&
				this.setState(() => ({
					selectedLeft: selectedLeft.filter((row) => row !== selectedRow)
				}))
			side === 'rightTable' &&
				this.setState(() => ({
					selectedRight: selectedRight.filter((row) => row !== selectedRow)
				}))
		}
	}

	/**
	 * to handle confirmation
	 *
	 */
	handleConfirm = () => {
		const {
			tabId,
			atributeCode,
			crudId,
			urlApi,
			crudCreateValue,
			setFormChanged
		} = this.props
		const { rightValues } = this.state

		crudCreateValue({
			crudName: crudId,
			urlApi: urlApi,
			action: 'confirmar',
			params: {
				[tabId]: atributeCode,
				lista: rightValues
			}
		})

		setFormChanged(false)
	}

	/**
	 * to handle search values
	 * @param event
	 */

	handleSearchChange = (event: any) => {
		event.target.id === 'searchLeft'
			? this.setState({ searchLeft: event.target.value })
			: this.setState({ searchRight: event.target.value })
	}

	handleFilterValues = (
		listValues: Array<any>,
		filterValue: string | number
	) => {
		const filteredResult: Array<any> = []
		const filterCase = String(filterValue).toUpperCase()

		listValues.forEach((value) => {
			let coincidence = false

			for (const key in value) {
				const propValue = String(value[key]).trim().toUpperCase()

				if (propValue.includes(filterCase)) {
					coincidence = true
				}
			}
			if (coincidence) {
				filteredResult.push(value)
			}
		})

		return filteredResult
	}

	render() {
		const { fields, disableForm, t, showWarning, handleWarning, valueId } =
			this.props
		const {
			sustainsClick,
			selectedLeft,
			selectedRight,
			leftValues,
			rightValues,
			searchLeft,
			searchRight
		} = this.state

		const propsTableLeft: ITableWithSelectionFields = {
			fields: this.handleFilterValues(leftValues, searchLeft),
			tableFields: fields,
			disableForm: disableForm,
			keyfield: valueId,
			sustainsClick: sustainsClick,
			selected: selectedLeft,
			setSelection: this.handleSelection,
			doDoubleClick: this.handleDoubleClick,
			label: 'leftTable'
		}

		const propsTableRight: ITableWithSelectionFields = {
			fields: this.handleFilterValues(rightValues, searchRight),
			tableFields: fields,
			disableForm: disableForm,
			keyfield: valueId,
			sustainsClick: sustainsClick,
			selected: selectedRight,
			setSelection: this.handleSelection,
			doDoubleClick: this.handleDoubleClick,
			label: 'rightTable'
		}

		return (
			<Fragment>
				<Row onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp}>
					<Col>
						<Alert variant={'dark'}>
							<b>{t('CRUDS.user_data.profiles.available')}</b>
						</Alert>
						<input
							id="searchLeft"
							disabled={false}
							value={searchLeft}
							onChange={this.handleSearchChange}
							placeholder={t('global.code_search')}
							className="form-control"
							style={{ height: '30px', fontSize: '10pt', marginBottom: '20px' }}
						/>
						{leftValues && <TableWithSelection {...propsTableLeft} />}
					</Col>
					{!disableForm && (
						<Col className={'mt-5'} sm={2}>
							<Row className={'mt-5'}>
								<Col className={'text-center'}>
									<Button
										style={{ minWidth: '145px' }}
										type={'button'}
										onClick={this.handleButtonClick('toRight')}
									>
										&gt;
									</Button>
								</Col>
							</Row>
							<Row className={'mt-2'}>
								<Col className={'text-center'}>
									<Button
										style={{ minWidth: '145px' }}
										type={'button'}
										onClick={this.handleButtonClick('toLeft')}
									>
										&lt;
									</Button>
								</Col>
							</Row>
							<Row className={'mt-2'}>
								<Col className={'text-center'}>
									<Button
										style={{ minWidth: '145px' }}
										type={'button'}
										onClick={this.handleButtonClick('allRight')}
									>
										&gt;&gt;
									</Button>
								</Col>
							</Row>
							<Row className={'mt-2'}>
								<Col className={'text-center'}>
									<Button
										style={{ minWidth: '145px' }}
										type={'button'}
										onClick={this.handleButtonClick('allLeft')}
									>
										&lt;&lt;
									</Button>
								</Col>
							</Row>
							<Row className={'mt-5'}>
								<Col className={'text-center'}>
									<Button
										style={{ minWidth: '145px' }}
										type={'button'}
										onClick={this.handleConfirm}
									>
										{t('global.confirm')}
									</Button>
								</Col>
							</Row>
						</Col>
					)}
					<Col>
						<Alert variant={'dark'}>
							<b>{t('CRUDS.user_data.profiles.assigned')}</b>
						</Alert>
						<input
							id="searchRight"
							disabled={false}
							value={searchRight}
							onChange={this.handleSearchChange}
							placeholder={t('global.code_search')}
							className="form-control"
							style={{ height: '30px', fontSize: '10pt', marginBottom: '20px' }}
						/>
						{rightValues && <TableWithSelection {...propsTableRight} />}
					</Col>
				</Row>
				<ConfirmModalNoButton
					modalTitle={t('CRUDS.modal.title_warning')}
					messageBody={t('CRUDS.modal.message_changes')}
					showModal={showWarning}
					handleCloseModal={() => handleWarning(false, 'close')}
					handleCancelButton={() => {
						handleWarning(false, 'cancel')
					}}
					handleSubmitButton={(e: any) => {
						this.handleConfirm()
						handleWarning(false, 'submit')
					}}
				/>
			</Fragment>
		)
	}
}

const mapStateToProps = ({ crudValues }: any) => {
	const { valuesList, valueUpdated } = crudValues
	return { valuesList, valueUpdated }
}

const connectForm = connect(mapStateToProps, {
	crudGetValuesList,
	crudCreateValue,
	crudClearValuesStore
})(DynamicTable)

export default withTranslation()(connectForm)
